import React, { useState, useEffect } from 'react';
import Navbar from '../components/home/Navbar';
import { FaUser, FaPaperclip, FaPaperPlane, FaFlag, FaSmile, FaMeh, FaFrown } from 'react-icons/fa';
import { fetchAPI } from '../utils/api';

export default function StudentFeedback() {
    const [feedbackData, setFeedbackData] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    useEffect(() => {
        const loadFeedback = async () => {
            try {
                const data = await fetchAPI('/public/get_feedback.php');
                setFeedbackData(data);
            } catch (err) {
                console.error('Failed to load feedback:', err);
                setError('Failed to load feedback. Please try again later.');
            } finally {
                setLoading(false);
            }
        };
        loadFeedback();
    }, []);
    return (
        <div className="min-h-screen bg-[#F8F9FB] pt-24 pb-12 px-4 sm:px-6 lg:px-8">
            <Navbar />

            <div className="max-w-3xl mx-auto space-y-8">
                {/* Header */}
                <div className="flex items-center justify-between mb-8">
                    <div className="flex items-center gap-3">
                        <FaFlag className="text-gray-900 text-xl" />
                        <h1 className="text-2xl font-bold text-gray-900 tracking-tight">
                            Feedback <span className="text-blue-600">2025</span><span className="text-xs text-gray-400 font-normal ml-1">feedback</span>
                        </h1>
                    </div>
                </div>

                {/* Feedback List */}
                {loading ? (
                    <div className="text-center py-12">
                        <div className="inline-block animate-spin rounded-full h-12 w-12 border-b-2 border-blue-600"></div>
                        <p className="mt-4 text-gray-500 font-medium">Loading feedback...</p>
                    </div>
                ) : error ? (
                    <div className="bg-red-50 border border-red-200 rounded-2xl p-6 text-center">
                        <p className="text-red-600 font-medium">{error}</p>
                    </div>
                ) : (
                    <div className="space-y-6">
                        {feedbackData.map((feedback) => (
                            <div key={feedback.id} className="bg-white rounded-2xl shadow-sm border border-gray-100 overflow-hidden hover:shadow-md transition-shadow duration-300">
                                <div className="p-6 space-y-4">
                                    {/* User Info Row */}
                                    <div className="flex items-start justify-between">
                                        <div className="flex items-center gap-3">
                                            <img
                                                src={`https://ui-avatars.com/api/?name=${encodeURIComponent(feedback.author)}&background=random`}
                                                alt={feedback.author}
                                                className="w-12 h-12 rounded-full object-cover border-2 border-white shadow-sm"
                                            />
                                            <div>
                                                <h3 className="font-bold text-gray-900 text-sm">{feedback.author}</h3>
                                                <p className="text-xs text-gray-400 flex items-center gap-1">
                                                    <span className="w-1 h-1 bg-gray-300 rounded-full"></span>
                                                    {feedback.time}
                                                </p>
                                            </div>
                                        </div>

                                        {/* Tags Row */}
                                        <div className="flex gap-2">
                                            {feedback.tags.map((tag, idx) => {
                                                let tagColor = "bg-blue-50 text-blue-600";
                                                if (tag === "Very Satisfied" || tag === "Satisfied") tagColor = "bg-purple-50 text-purple-600";
                                                if (tag === "Neutral") tagColor = "bg-pink-50 text-pink-600";
                                                if (tag === "Course" || tag === "Content") tagColor = "bg-blue-50 text-blue-600";

                                                return (
                                                    <span key={idx} className={`px-3 py-1 rounded-full text-[10px] font-bold uppercase tracking-wider ${tagColor}`}>
                                                        {tag}
                                                    </span>
                                                );
                                            })}
                                            <button className="text-gray-400 hover:text-gray-600 p-1">
                                                <div className="flex flex-col gap-0.5">
                                                    <span className="w-1 h-1 bg-gray-400 rounded-full"></span>
                                                    <span className="w-1 h-1 bg-gray-400 rounded-full"></span>
                                                    <span className="w-1 h-1 bg-gray-400 rounded-full"></span>
                                                </div>
                                            </button>
                                        </div>
                                    </div>

                                    {/* Content Section */}
                                    <div className="space-y-2">
                                        <h4 className="text-lg font-bold text-gray-900 leading-tight">
                                            {feedback.headline}
                                        </h4>
                                        <p className="text-sm text-gray-500 leading-relaxed font-medium">
                                            {feedback.content}
                                        </p>
                                    </div>

                                    {/* Interaction Area */}
                                    <div className="pt-4 flex items-center justify-between border-t border-gray-50 bg-[#FCFDFF] -mx-6 px-6 py-4">
                                        <div className="flex-1">
                                            <input
                                                type="text"
                                                placeholder="Replay Feedback"
                                                className="w-full bg-transparent text-sm text-gray-400 focus:outline-none placeholder-gray-300 font-medium"
                                            />
                                        </div>
                                        <div className="flex items-center gap-4 text-gray-400">
                                            <button className="hover:text-gray-600 transition-colors">
                                                <FaPaperclip size={18} />
                                            </button>
                                            <button className="w-8 h-8 rounded-full bg-green-50 text-green-500 flex items-center justify-center hover:bg-green-100 transition-colors">
                                                <FaPaperPlane size={14} />
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        ))}
                    </div>
                )}

                {/* Footer Decor */}
                <div className="text-center pt-8">
                    <p className="text-xs text-gray-400 font-medium">End of Feedback Stream</p>
                </div>
            </div>
        </div>
    );
}
